module.exports = __webpack_public_path__ + "img/ag.b531445.svg";